import classnames from 'classnames';
import type { FC } from 'react';

import { Link } from '@/domains/core/routing/components/Link';
import { generateUrl } from '@/domains/productDiscovery/algolia/components/AlgoliaProductCard/AlgoliaProductCard.utils';
import { isMobile } from '@/domains/productDiscovery/HeaderLeonidas/utils/isMobile';
import { getDelivery } from '@/domains/productDiscovery/ProductCard/utils/getDelivery';
import { useDeliveryMeta } from '@/domains/productDiscovery/ProductPage/common/modules/Delivery/delivery.ducks';

import OutlineBundleCheckbox from './components/OutlineBundleCheckbox/OutlineBundleCheckbox';
import OutlineBundleProductCard from './components/OutlineBundleProductCard/OutlinebundleProductCard';
import type { IOutlineBundleProduct } from './OutlineBundleProduct.interfaces';

import styles from './outlineBundleProduct.module.scss';

export const OutlineBundleProduct: FC<IOutlineBundleProduct> = ({
  product,
  withCheckbox,
  index,
}) => {
  const meta = useDeliveryMeta();
  const isMainProduct = index === 0;

  const deliveryInfos = isMainProduct
    ? getDelivery({
        ...product,
        hasFreeDelivery: meta.hasFreeDelivery,
      })
    : getDelivery(product);
  return (
    <div
      className={classnames(styles.wrapper, {
        [styles.withCheckbox]: withCheckbox,
      })}
    >
      {withCheckbox && (
        <OutlineBundleCheckbox
          isInBundle={product.isInBundle}
          modelId={product.modelId}
        />
      )}
      <div className={styles.productWrapper}>
        {isMobile() && !isMainProduct ? (
          <Link
            className={styles.link}
            href={`p/${generateUrl({
              url: product.url,
              modelId: product.modelId,
              articleId: product.articleId,
              modelsCount: product.modelsCount,
            })}`}
          >
            <OutlineBundleProductCard
              {...product}
              delivery={deliveryInfos}
              isMainProduct={isMainProduct}
            />
          </Link>
        ) : (
          <OutlineBundleProductCard
            {...product}
            delivery={deliveryInfos}
            isMainProduct={isMainProduct}
          />
        )}
      </div>
    </div>
  );
};
